import TabsToolbar from 'Components/TabsToolbar';
import { actions as drawerViewActions } from 'ducks/drawerView';
import { actions as equipmentActions } from 'ducks/equipment';
import React from 'react';
import { connect } from 'react-redux';
import icons from 'utils/ui/icons';

const Toolbar = props => {
    const { disableButtons, equipment } = props;
    const { clearEntity, editEntity, newEntity, remove } = props;

    const onDelete = () => remove(equipment.id, () => clearEntity());
    const handleEditEquipment = () => editEntity(equipment.id, 'EQUIPMENT');
    const handleNewReading = () => newEntity('READING', equipment.id);

    const
        buttons = [
            { icon: icons.editConfig, onClick: handleEditEquipment, tooltip: 'Edit' },
            {
                icon: icons.trash,
                confirmationHeader: 'Delete Confirmation',
                confirmationText: 'Are you sure you want to delete this entity?',
                onClick: onDelete,
                tooltip: 'Delete'
            }
        ],
        tabs = [{ text: 'Equipment details', id: 'properties' }];

    if (equipment.can_have_readings) {
        buttons.push({ icon: icons.addEntity, onClick: handleNewReading, tooltip: 'Add reading' });

        tabs.push({ text: 'Readings', id: 'readings' });
    }

    tabs.push({ text: 'Devices', id: 'devices' });

    return (
        <TabsToolbar buttons={disableButtons ? [] : buttons} tabs={tabs}/>
    );
};

const mapDispatchToProps = ({
    clearEntity: drawerViewActions.clearEntity,
    editEntity: drawerViewActions.editEntity,
    newEntity: drawerViewActions.newEntity,
    remove: equipmentActions.remove,
    viewEntity: drawerViewActions.viewEntity
});

export default connect(null, mapDispatchToProps)(Toolbar);
